// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { viewStyles } from "@tps/Overrides/Widgets/ProductDetails/ProductDetailsView";
import { xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

viewStyles.wrapper = {
    css: css`
        display: flex;
        gap: 22px;
        width: 100%;

        ${xScreen("lte", "md")} {
            gap: 20px;
            flex-wrap: wrap;
        }
        ${xScreen("lte", 767)} {
            gap: 52px;
        }
    `,
};
viewStyles.leftSection = {
    css: css`
        display: flex;
        width: calc(50% - 11px);
        flex-wrap: wrap;
        ${xScreen("lte", "md")} {
            width: 358px;
            gap: 20px;
        }
        ${xScreen("lte", 767)} {
            width: 100%;
            gap: 20px;
        }
    `,
};
viewStyles.rightSection = {
    css: css`
        width: calc(50% - 11px);
        ${xScreen("lte", "md")} {
            width: calc(100% - 378px);
            flex-grow: 1;
        }
        ${xScreen("lte", 767)} {
            width: 100%;
        }
    `,
};
viewStyles.imagesSection = {
    css: css`
        flex: 0 0 204px;
        max-width: 204px;
        ${xScreen("lte", "md")} {
            flex: 0 1 358px;
            max-width: 358px;
        }
        ${xScreen("lte", 767)} {
            flex: 1 0 100%;
            max-width: 100%;
        }
    `,
};
viewStyles.mainSection = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 20px;
        flex: 1 1 0%;
        padding-left: 22px;
        ${xScreen("lte", "md")} {
            padding-left: 0;
            flex: 0 1 100%;
        }
        ${xScreen("lte", 767)} {
            margin-top: 12px;
        }
    `,
};
viewStyles.productTitleHiddenMobile = {
    css: css`
        flex-basis: 100%;
    `,
};
viewStyles.productCarouselsMobile = {
    css: css`
        width: 100%;
        display: none;
        ${xScreen("lte", 767)} {
            display: block;
        }
    `,
};
viewStyles.productCarouselDesktop = {
    css: css`
        width: 100%;
        margin-top: 32px;
        ${xScreen("lte", 767)} {
            display: none;
        }
    `,
};
